var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 56,
    viewBox: "0 0 82 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4986 49.8696C31.4644 57.9655 23.5374 56.8946 16.9273 50.2106C13.4737 46.6927 10.4739 42.7586 7.99765 38.4998C5.21567 33.4188 2.89724 28.0987 1.07035 22.6039C-3.97782 9.66723 10.2581 5.00237 14.0915 3.51625C18.7228 2.48737 23.455 1.97889 28.1998 2.00032C33.3533 2.03589 38.4928 2.5421 43.5536 3.51261C53.0484 7.96298 58.9709 9.11974 55.128 22.6003C55.128 22.6003 52.9266 31.4959 48.876 38.4961C46.385 42.7662 43.2184 46.6069 39.4986 49.8696Z",
    fill: "#B7B7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5938 35.5553C31.5983 33.2128 32.1411 30.9027 33.1802 28.8039C34.2194 26.7052 35.727 24.874 37.5863 23.4523C39.4455 22.0307 41.6066 21.0565 43.9022 20.6054C46.1978 20.1542 48.5662 20.2382 50.8242 20.8507L71.9222 2H80.0005V11.0577H74.2082V19.1116H67.7896V26.3916L60.8406 29.5922C61.7213 31.6724 62.1293 33.9227 62.0351 36.1802C61.9409 38.4376 61.3468 40.646 60.2959 42.6454C59.245 44.6448 57.7635 46.3854 55.9585 47.7412C54.1535 49.0971 52.0702 50.0343 49.8592 50.4851C47.6482 50.9359 45.3647 50.889 43.174 50.3479C40.9833 49.8067 38.9401 48.7848 37.1921 47.356C35.4441 45.9273 34.0351 44.1274 33.0669 42.0865C32.0987 40.0456 31.5955 37.8148 31.5938 35.5553Z",
    stroke: "#4F41F2",
    strokeWidth: 3.01075,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.986 10.1406L54.5312 24.6003",
    stroke: "#4F41F2",
    strokeWidth: 3.01075,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0798 39.8685C48.0267 39.8685 49.605 38.2881 49.605 36.3386C49.605 34.389 48.0267 32.8086 46.0798 32.8086C44.133 32.8086 42.5547 34.389 42.5547 36.3386C42.5547 38.2881 44.133 39.8685 46.0798 39.8685Z",
    stroke: "#4F41F2",
    strokeWidth: 3.01075
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.ce7b164897da88673bef1376ced08e1a.svg";
export { ForwardRef as ReactComponent };